import { useEffect, useState } from 'react';
import tinycolor from 'tinycolor2';

const useColorPicker = (initialColor: string) => {
  const { h: initialHue, s: initialSaturation, v: initialValue } = tinycolor(initialColor).toHsv();

  const [hue, setHue] = useState(initialHue);
  const [saturation, setSaturation] = useState(initialSaturation);
  const [value, setValue] = useState(initialValue);
  const [currentColor, setCurrentColor] = useState(initialColor);

  useEffect(() => {
    setCurrentColor(tinycolor(`hsv(${hue}, ${saturation}, ${value})`).toHexString());
  }, [hue, saturation, value, initialColor]);

  useEffect(() => {
    const { h } = tinycolor(initialColor).toHsv();
    setHue(h);
  }, [initialColor]);

  const setSV = (s: number, v: number) => {
    setValue(v);
    setSaturation(s);
  };

  const getBoardBg = () => tinycolor(`hsv(${hue}, 100, 100)`).toRgbString();

  const setH = (h: number) => setHue(h);

  return {
    hue,
    setH,
    setSV,
    value,
    getBoardBg,
    saturation,
    currentColor
  };
};

export default useColorPicker;
